const mediaItems = [
  {
    title: '最新悬疑剧《暗夜追踪》热播中',
    tag: '悬疑',
    views: '128.6万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20suspense%20thriller%20scene%20with%20dark%20moody%20lighting%2C%20silhouette%20of%20detective%20in%20rainy%20alley%2C%20neon%20reflections%20on%20wet%20pavement%2C%20film%20noir%20aesthetic%2C%20modern%20crime%20drama%20visual%20style%2C%20mysterious%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20photography%2C%20professional%20movie%20poster%20quality&width=800&height=450&seq=douhua-media-01&orientation=landscape',
  },
  {
    title: '古装大戏《锦绣浮生》全集上线',
    tag: '古装',
    views: '256.3万',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20period%20drama%20scene%2C%20traditional%20hanfu%20costumes%20in%20palace%20garden%2C%20soft%20golden%20hour%20lighting%2C%20cherry%20blossom%20petals%20falling%2C%20royal%20aesthetic%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20historical%20romance%20drama%20feel&width=800&height=450&seq=douhua-media-02&orientation=landscape',
  },
  {
    title: '动作巨制《极限营救》首发上线',
    tag: '动作',
    views: '189.2万',
    img: 'https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20scene%20with%20explosive%20urban%20chase%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20fast%20cars%20on%20city%20streets%2C%20dynamic%20motion%20blur%2C%20cinematic%20lighting%2C%20modern%20blockbuster%20aesthetic%2C%20intense%20thriller%20atmosphere%2C%20professional%20film%20quality&width=800&height=450&seq=douhua-media-03&orientation=landscape',
  },
  {
    title: '甜宠剧《心动频率》甜蜜开播',
    tag: '爱情',
    views: '312.8万',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20scene%20with%20young%20couple%20in%20modern%20urban%20setting%2C%20warm%20sunset%20backlight%2C%20soft%20bokeh%20city%20lights%20background%2C%20sweet%20tender%20atmosphere%2C%20pastel%20warm%20tones%2C%20contemporary%20romance%20drama%20aesthetic%2C%20cinematic%20photography%2C%20emotional%20storytelling%20vibe&width=800&height=450&seq=douhua-media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">编辑精选热门影片，高清不缓冲即刻观看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold font-label">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </div>
                  <span className="text-xs text-background-50/90 font-label">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}